$(document).ready(function() {
    $('body').on('submit', '.lw-ajax-form', function(e) {
        e.preventDefault();
        var $thisForm                   = $(this),
            $thisFormSubmitButton       = $thisForm.find("input[type='submit']"),
            thisFormSubmitButtonName    = $thisFormSubmitButton.val();
            $thisFormSubmitButton.val('Processing...').attr('disabled', true);

            $.ajax({
                cache: false,
                type: 'post',
                url: $thisForm.attr('action'),
                data: $thisForm.serialize(),
                dataType:'JSON',
            }).done(function(returnData) {
                
                if(returnData.data.error) {
                }
                if(returnData.data.success) {
                }
                
                $('#lwPageTitle').text(returnData.data.pageTitle);
                $('#lwPageContent').html(returnData.page);
                $('.has-error:first').find('input').focus();
                
            }).fail(function(returnData){

                $thisFormSubmitButton.val(thisFormSubmitButtonName).removeAttr('disabled');

            });
        
    });

    $('body').on('click', ".lw-ajax-link, .lw-ajax-a-links a:not(.lw-ajax-except-me)", function(e){
            e.preventDefault();
            
            var $thisLink   = $(this),
                linkAction  = $thisLink.attr('href');

               $.ajax({
                  cache: false,
                  type: "get",
                  url: linkAction,
                  dataType:'JSON',
                }).done(function(returnData) {
                  
                 if(returnData.data.error) {

                 }

                if(returnData.data.success) {

                 }

                $('#pageContent').html(returnData.page);

                }).fail(function(returnData) {

                });
        });
});